import { MapUtils } from '../../utility/map-utils.js';
import { DataModel, SerializationContext, DataModelBuilder,
  SerializedData, cloneList, isSameList } from '../dto/dto.js';

export class FestivalLikes extends DataModel {
  static readonly TYPE_ID: string = '88973c69b66c490f9111e3e89e1b9ee0';

  constructor(
    public readonly events: string[],
  ) {
    super();
  }

  get $typeId(): string {
    return FestivalLikes.TYPE_ID;
  }

  static fromMap(context: SerializationContext, map: SerializedData): FestivalLikes {
    return new FestivalLikes(
        MapUtils.getList<string>(map, 'events', (value) => value as string),
    );
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'events': this.events,
    };
  }

  clone(): this {
    return new FestivalLikes(
        cloneList(this.events),
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return isSameList(other.events, this.events);
  }
}

export class FestivalLikesBuilder extends DataModelBuilder<FestivalLikes> {
  build(context: SerializationContext, map: SerializedData): FestivalLikes {
    return FestivalLikes.fromMap(context, map);
  }
}
